import { GenerateInitialUserAnswer } from "seneca-common/features/module/module-types/types";

import { checkWord } from "../../wordfill/logic/answers";
import { Answer, Content, Score, StepScore, TestableWord } from "../types";
import { makeWordId } from "./utils";
import { getAnswerForWord } from "./utils/answer";

export const generateInitialUserAnswer: GenerateInitialUserAnswer<
  Content,
  Answer
> = ({ content }) => {
  return {
    steps: content.steps.map(step => ({}))
  };
};

export function markAnswer(content: Content, answer: Answer): Score {
  let testedWords = 0;
  let correctAnswers = 0;
  const steps: any[] = [];

  content.steps.forEach((step, stepIndex) => {
    const stepScore: StepScore = {};

    step.equation.forEach((word: any, i: number) => {
      if (typeof word !== "string" && word.testing) {
        testedWords++;

        const wordId = makeWordId(word.word, i);

        stepScore[wordId] = wordIsCorrect(wordId, word, stepIndex, answer);

        if (stepScore[wordId]) {
          correctAnswers++;
        }
      }
    });

    steps.push(stepScore);
  });

  return {
    score: Number((correctAnswers / testedWords).toFixed(2)),
    steps
  };
}

function wordIsCorrect(
  wordId: string,
  word: TestableWord,
  stepIndex: number,
  answer: Answer
) {
  const answerText = getAnswerForWord(stepIndex, wordId, answer);

  const { otherPermittedWords = [], word: correctAnswer } = word;

  return [correctAnswer]
    .concat(otherPermittedWords)
    .some(w => checkWord(w, answerText));
}
